<template>
    <header class="c-header print-hidden" :class="{'open-menu': isMenuOpen}" role="banner">
        <div class="c-header__main">
            <div class="c-header__logo">
                <a href="/"><img class="logo" width="150" alt="DigiScore by DW" src="@/assets/images/logos/logo-digiscore.jpg"></a>
            </div>
            <NavComponent />
        </div>
        <button class="nav-btn" @click.prevent="toggleMenu">
          <span class="nav-toggle">
            <b class="top"></b>
            <b class="middle"></b>
            <b class="bottom"></b>
          </span>
          <span class="nav-btn__label">
            <span class="nav-btn__label-menu">Menu</span>
            <span class="nav-btn__label-close">Fermer</span>
          </span>
        </button>
    </header>
</template>

<script>
import NavComponent from '@/components/Nav.vue';

export default {
  name: 'Header',
  components: {
    NavComponent,
  },
  data() {
    return {
      isMenuOpen: false,
    };
  },
  mounted() {
    this.$eventHub.on('closeMenu', (value) => {
      this.isMenuOpen = value;
    });
  },
  watch: {
    $route(to, from) {
      if (to.path !== from.path) {
        this.isMenuOpen = false;
      }
    },
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
};
</script>
